<template>
  <carousel
    :per-page="1"
    pagination-color="#B3BCCB"
    pagination-active-color="#000000"
    class="info-carousel"
    :pagination-padding="7"
    :pagination-size="5"
    :navigation-enabled="false"
    :navigation-click-target-size="5"
  >
    <slide>
      <h3 class="heading -quaternary">Programs don&#39;t auto-complete.</h3>
      <p>Be sure to mark your program as complete when you are done.</p>
    </slide>

    <slide>
      <h3 class="heading -quaternary">Programs can be rescheduled.</h3>
      <p>You can schedule, reschedule, and delete programs, routines, and meal plans.</p>
    </slide>

    <slide v-if="extraSlides">
      <h3 class="heading -quaternary">You can swap workouts in a program.</h3>
      <p>
        If you want to do a different workout than the one scheduled, simply select Swap Workout and
        choose from similar options, pick a favorite, or browse workouts you’ve tagged.
      </p>
    </slide>

    <slide v-if="extraSlides">
      <h3 class="heading -quaternary">You can save changes you make to a program.</h3>
      <p>
        If you&#39;ve swapped workouts in a program and want to keep the changes, you can create a
        copy of your personalized program.
      </p>
    </slide>

    <slide v-if="extraSlides">
      <h3 class="heading -quaternary">Any program can be copied to a custom routine.</h3>
      <p>
        You can completely customize any program by making a copy as a routine. Once it is a routine
        you can change anything and everything to make it your own.
      </p>
    </slide>
  </carousel>
</template>

<script setup>
import { computed } from 'vue'
import { Carousel, Slide } from '@jambonn/vue-concise-carousel'

import { useUserAuthStore } from '@/stores/user-auth'

/** STATE **/
const userAuthStore = useUserAuthStore()

const extraSlides = computed(() => !!userAuthStore.features.PLAN_COPY)
</script>
